import axiosInstance from './axiosInstance';

export const login = (data) => axiosInstance.post('/auth/login', data);

// Registration (2-step with email OTP)
export const sendRegisterOTP = (data) => axiosInstance.post('/auth/send-register-otp', data);
export const verifyRegisterOTP = (data) => axiosInstance.post('/auth/verify-register-otp', data);
export const lookupReferralCode = (code) => axiosInstance.get('/auth/referral-lookup', { params: { code } });

// User profile
export const getMe = () => axiosInstance.get('/auth/me');
export const updateProfile = (data) => axiosInstance.put('/auth/profile', data);
export const changePassword = (data) => axiosInstance.put('/auth/change-password', data);

// USDT address validation
export const validateUSDTAddress = (address) => axiosInstance.post('/auth/validate-usdt-address', { address });
export const validateAddressOnChain = (address) => axiosInstance.post('/auth/validate-address-onchain', { address });

// Password reset (with email OTP + 30s rate limit)
export const forgotPassword = (data) => axiosInstance.post('/auth/forgot-password', data);
export const resetPassword = (data) => axiosInstance.post('/auth/reset-password', data);

// Profile update requests (require admin approval)
export const sendProfileOTP = () => axiosInstance.post('/auth/send-profile-otp');
export const getPublicConfig = () => axiosInstance.get('/auth/public-config');
export const submitProfileUpdateRequest = (data) => axiosInstance.post('/auth/profile-update-request', data);
export const getMyProfileUpdateRequests = () => axiosInstance.get('/auth/profile-update-requests');
